// components/Aside.js
import { useNavigate } from "react-router-dom";

function Aside({ onSelect, selected, pendingCount = 0 }) {
  const navigate = useNavigate();
  const colors = {
    activeBg: "#ffcc00",
    activeText: "#0e0e0e",
    inactiveBg: "#000000",
    inactiveText: "#ffffff",
    badge: "#e74c3c",
  };

  const menuItems = [
    { key: "تابلو", label: "تابلو" },
    { key: "ایجاد مظنه جدید", label: "ایجاد مظنه جدید" },
    { key: "درخواست ورود", label: "درخواست ورود" },
    { key: "لیست کاربران", label: "لیست کاربران" },
    { key: "تراکنش جدید", label: "تراکنش جدید", hasBadge: true },
    { key: "لیست تراکنش ها", label: "لیست تراکنش ها" },
    { key: "امور ثبت حواله", label: "امور ثبت حواله" },
    { key: "ایجاد گردش حساب", label: "ایجاد گردش حساب" },
    { key: "ویترین و پیام ها", label: "ویترین و پیام ها" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    navigate("/login", { replace: true });
  };

  return (
    <div className="Aside" style={{ backgroundColor: colors.inactiveBg }}>
      <h3>آبشده احمدی</h3>
      <h4>
        یکشنبه <br />
        1405/02/07
      </h4>

      {menuItems.map((item) => (
        <div
          key={item.key}
          style={{
            position: "relative",
            display: "inline-block",
            width: "100%",
          }}
        >
          <p
            onClick={() => onSelect(item.key)}
            style={{
              cursor: "pointer",
              backgroundColor: selected === item.key ? colors.activeBg : colors.inactiveBg,
              color: selected === item.key ? colors.activeText : colors.inactiveText,
              padding: "10px 15px",
              borderRadius: selected === item.key ? "8px" : "0",
              transition: "all 0.2s ease",
              fontWeight: selected === item.key ? "bold" : "normal",
              transform: selected === item.key ? "translateX(5px)" : "translateX(0)",
            }}
          >
            {item.label}
          </p>

          {item.hasBadge && pendingCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: "5px",
                right: "10px",
                backgroundColor: colors.badge,
                color: "#fff",
                borderRadius: "50%",
                width: "22px",
                height: "22px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                animation: "pulse 1.5s infinite",
              }}
            >
              {pendingCount > 9 ? "9+" : pendingCount}
            </span>
          )}
        </div>
      ))}

      <button type="button" className="AdminLogoutButton" onClick={handleLogout}>
        خروج از پنل
      </button>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

export default Aside;
